/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youreventhasbeencreatedsuccessfully5Inputs */

const en_youreventhasbeencreatedsuccessfully5 = /** @type {(inputs: Youreventhasbeencreatedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your event has been created successfully.`)
};

const de_youreventhasbeencreatedsuccessfully5 = /** @type {(inputs: Youreventhasbeencreatedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Event wurde erstellt.`)
};

/**
* | output |
* | --- |
* | "Your event has been created successfully." |
*
* @param {Youreventhasbeencreatedsuccessfully5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const youreventhasbeencreatedsuccessfully5 = /** @type {((inputs?: Youreventhasbeencreatedsuccessfully5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youreventhasbeencreatedsuccessfully5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youreventhasbeencreatedsuccessfully5(inputs)
	return de_youreventhasbeencreatedsuccessfully5(inputs)
});
export { youreventhasbeencreatedsuccessfully5 as "yourEventHasBeenCreatedSuccessfully" }